import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useStore from "../../store";
import withAuth from "../Auth/withAuth";

function Lessons() {
  const navigate = useNavigate();

  const { logout, setPageTitle, tenantId, data, isLoggedIn } = useStore(
    (state) => state
  );
  useEffect(() => {
    setPageTitle("Lessons");
  }, []);

  useEffect(() => {
    if (!isLoggedIn) {
      logout();
      navigate(`/?tenantId=${tenantId}`);
    }
  }, []);

  return (
    <div>
      <iframe
        title="my-iframe"
        width="100%"
        height="1000px"
        src={`https://lom.eduedges.com/lessons?id_token=${data.idToken.jwtToken}&access_token=${data.accessToken.jwtToken}&tenant_id=${tenantId}`}
      ></iframe>
    </div>
  );
}

export default withAuth(Lessons);
